import React from 'react';

const Projects = () => {
  const projects = [
    {
      title: 'GYM Management System',
      description: 'A system for managing gym operations using C# and MySQL.',
      tags: ['C#', 'MySQL'],
      liveDemo: 'https://example.com/gym-demo', // Replace with real link if available
      sourceCode: 'https://github.com/hazimmalik/gym-management-system' // Replace
    },
    {
      title: 'Asthma Diagnostic From Respiratory Audio Data',
      description: 'Research project using Python, Colab, NumPy, Librosa, PyTorch, Sklearn for asthma diagnosis from audio.',
      tags: ['Python', 'NumPy', 'Librosa', 'PyTorch', 'Scikit-learn', 'Colab'],
      liveDemo: 'https://example.com/asthma-audio-demo',
      sourceCode: 'https://github.com/hazimmalik/asthma-diagnostic'
    },
    {
      title: 'Ensemble-Learning Intrusion-Detection Model for Ultra-Dense IoT Networks',
      description: 'Built an ensemble-learning system to detect anomalous traffic patterns in large-scale IoT environments.',
      tags: ['Python', 'ML', 'Ensemble Methods', 'IoT Security'],
      liveDemo: 'https://example.com/iot-intrusion-demo',
      sourceCode: 'https://github.com/hazimmalik/iot-intrusion-detection'
    },
    {
      title: 'Efficient Graph Classification through Transfer Learning in Graph Neural Networks',
      description: 'Research on transfer learning in GNNs using Python, Graph Neural Networks, TensorFlow, TUdataset.',
      tags: ['Python', 'GNNs', 'TensorFlow', 'TUdataset'],
      liveDemo: 'https://example.com/graph-transfer-demo',
      sourceCode: 'https://github.com/hazimmalik/graph-transfer-learning'
    },
    {
      title: 'Heart Disease Detection from Tabular Data',
      description: 'Detection of heart disease from clinical and diagnostic attributes using Python, ML, Neural Networks, Colab.',
      tags: ['Python', 'ML', 'Neural Networks', 'Colab'],
      liveDemo: 'https://example.com/heart-disease-demo',
      sourceCode: 'https://github.com/hazimmalik/heart-disease-detection'
    },
    {
      title: 'Hybrid GNN Model for Stewart Platform Legs Orientation Prediction',
      description: 'Developed a Hybrid GNN Model to predict Stewart Platform Legs and their orientation using Python, GNNs, TensorFlow, Colab.',
      tags: ['Python', 'GNNs', 'TensorFlow', 'Colab'],
      liveDemo: 'https://example.com/stewart-platform-demo',
      sourceCode: 'https://github.com/hazimmalik/stewart-platform-gnn'
    },
    {
      title: 'Privacy-Preserving XGBoost-MLP Fusion Model using Homomorphic Encryption',
      description: 'Implemented a Privacy-Preserving XGBoost-MLP Fusion Model using Homomorphic Encryption in Python, XGBoost, MLP, Colab.',
      tags: ['Python', 'XGBoost', 'MLP', 'Homomorphic Encryption', 'Colab'],
      liveDemo: 'https://example.com/xgboost-mlp-demo',
      sourceCode: 'https://github.com/hazimmalik/xgboost-mlp-fusion'
    },
    {
      title: 'Hybrid Model for Heart Disease, Breast Cancer, and Thyroid Cancer Detection from Image Datasets',
      description: 'Developed a Hybrid Model for detecting multiple cancers from image datasets using Python, GNNs, TensorFlow, Kaggle, Colab.',
      tags: ['Python', 'GNNs', 'TensorFlow', 'Kaggle', 'Colab'],
      liveDemo: 'https://example.com/cancer-detection-demo',
      sourceCode: 'https://github.com/hazimmalik/cancer-detection-hybrid'
    },
    {
      title: 'Secure Digital-Signature System integrating EDDSA and Nonblind Watermarking',
      description: 'Designed a Secure Digital-Signature System for Document Authentication using Python, Cryptography, EDDSA, Watermarking.',
      tags: ['Python', 'Cryptography', 'EDDSA', 'Watermarking'],
      liveDemo: 'https://example.com/digital-signature-demo',
      sourceCode: 'https://github.com/hazimmalik/secure-signature-system'
    },
    {
      title: 'HE-GGL Encrypted Graph-Learning Framework',
      description: 'Created the HE-GGL Encrypted Graph-Learning Framework, combining GAT-GIN representations with Logistic-Regression Inference using Python, GNNs, Homomorphic Encryption, Colab.',
      tags: ['Python', 'GNNs', 'Homomorphic Encryption', 'Colab'],
      liveDemo: 'https://example.com/he-ggl-demo',
      sourceCode: 'https://github.com/hazimmalik/he-ggl-framework'
    },
    {
      title: 'AsthmaAudio-GNN: Hybrid GCNGAT–Transformer Ensemble',
      description: 'Developed AsthmaAudio-GNN with stacking and explainability for Respiratory-Audio Diagnosis using Python, GNNs, Transformers, Audio ML, Colab.',
      tags: ['Python', 'GNNs', 'Transformers', 'Audio ML', 'Colab'],
      liveDemo: 'https://example.com/asthmaaudio-gnn-demo',
      sourceCode: 'https://github.com/hazimmalik/asthmaaudio-gnn'
    }
  ];

  return (
    <div 
      style={{ 
        minHeight: '100vh', 
        padding: '4rem 1rem', 
        background: 'linear-gradient(to bottom, var(--bg-primary), var(--bg-secondary))', 
        position: 'relative' 
      }}
    >
      {/* Subtle Noise Overlay */}
      <div 
        style={{ 
          position: 'absolute', 
          top: 0, 
          left: 0, 
          width: '100%', 
          height: '100%', 
          backgroundImage: "url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 300 300\"%3E%3Cfilter id=\"n\"%3E%3CfeTurbulence type=\"fractalNoise\" baseFrequency=\".7\" numOctaves=\"3\" stitchTiles=\"stitch\"/%3E%3C/filter%3E%3Crect width=\"100%\" height=\"100%\" filter=\"url(%23n)\" opacity=\"0.03\"/%3E%3C/svg%3E')", 
          backgroundSize: 'cover', 
          pointerEvents: 'none' 
        }} 
      />
      
      <h1 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '3rem' }}>Projects</h1>
      
      <div 
        style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
          gap: '2rem', 
          maxWidth: '1200px', 
          margin: '0 auto' 
        }}
      >
        {projects.map((project, index) => (
          <div 
            key={index}
            style={{ 
              backgroundColor: 'var(--card-bg)', 
              border: '1px solid var(--card-border)', 
              borderRadius: '16px', 
              padding: '1.5rem', 
              transition: 'all 0.3s ease', 
              cursor: 'pointer' 
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.transform = 'translateY(-4px)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--card-border)'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            <h3 style={{ fontSize: '1.4rem', marginBottom: '0.5rem' }}>{project.title}</h3>
            <p style={{ fontSize: '1rem', color: 'var(--text-muted)', marginBottom: '1rem' }}>{project.description}</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1.5rem' }}>
              {project.tags.map((tag) => (
                <span key={tag} style={{ backgroundColor: 'rgba(255,255,255,0.1)', padding: '0.25rem 0.75rem', borderRadius: '9999px', fontSize: '0.875rem', color: 'var(--text-main)' }}>
                  {tag}
                </span>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <a href={project.liveDemo} target="_blank" rel="noopener noreferrer">
                <button 
                  style={{ 
                    backgroundColor: 'var(--accent)', 
                    color: '#FFFFFF', 
                    padding: '0.75rem 1.5rem', 
                    border: 'none', 
                    borderRadius: '12px', 
                    cursor: 'pointer' 
                  }}
                >
                  Live Demo
                </button>
              </a>
              <a href={project.sourceCode} target="_blank" rel="noopener noreferrer">
                <button 
                  style={{ 
                    backgroundColor: 'transparent', 
                    color: 'var(--accent)', 
                    padding: '0.75rem 1.5rem', 
                    border: '1px solid var(--accent)', 
                    borderRadius: '12px', 
                    cursor: 'pointer' 
                  }}
                >
                  Source Code
                </button>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;